import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';
import {hasInvalidFileSize} from '../../utils/file';

@Component({
    selector: 'app-file-upload-button',
    templateUrl: './file-upload-button.component.html',
    styleUrls: ['./file-upload-button.component.scss'],
    standalone: false
})
export class FileUploadButtonComponent {
    @Input() accept: string | undefined;

    @Output() fileSelect = new EventEmitter<File[]>();

    onFileSelect(event: any): void {
        const {files} = event.target;

        const fileList: File[] = Array.from(files);

        this.fileSelect.emit(fileList);
    }
}
